import TimeslotApiUtils from '../utils/api/timeslot';

// TIMESLOT_AVAILABILITIES action types removed - migrated to TanStack Query
export const FETCH_TIMESLOT_STATUSES_SENT = 'FETCH_TIMESLOT_STATUSES_SENT';
export const FETCH_TIMESLOT_STATUSES_SUCCEEDED =
  'FETCH_TIMESLOT_STATUSES_SUCCEEDED';
export const FETCH_TIMESLOT_STATUSES_FAILED = 'FETCH_TIMESLOT_STATUSES_FAILED';
export const FETCH_TIMESLOT_STATUSES_BY_TUTOR_SENT =
  'FETCH_TIMESLOT_STATUSES_BY_TUTOR_SENT';
export const FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED =
  'FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED';
export const FETCH_TIMESLOT_STATUSES_BY_TUTOR_FAILED =
  'FETCH_TIMESLOT_STATUSES_BY_TUTOR_FAILED';
export const FETCH_TUTORS_ON_SLOT_SENT = 'FETCH_TUTORS_ON_SLOT_SENT';
export const FETCH_TUTORS_ON_SLOT_SUCCEEDED = 'FETCH_TUTORS_ON_SLOT_SUCCEEDED';
export const FETCH_TUTORS_ON_SLOT_FAILED = 'FETCH_TUTORS_ON_SLOT_FAILED';
export const CLEAR_TUTORS_ON_SLOT = 'CLEAR_TUTORS_ON_SLOT';

// Slot availability action creators removed - migrated to TanStack Query
// See: apps/lb-classroom/src/hooks/queries/use-slot-availabilities-query.ts

export function fetchSent(opts) {
  return {
    type: FETCH_TIMESLOT_STATUSES_SENT,
    payload: { opts },
  };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_TIMESLOT_STATUSES_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return {
    type: FETCH_TIMESLOT_STATUSES_FAILED,
  };
}

export function fetch(
  timeZone,
  opts = {
    page: 1,
    date: null,
    startTime: 1,
    endTime: 49,
    sortOption: 'availability',
  },
) {
  return (dispatch) => {
    dispatch(fetchSent(opts));
    const args = Object.assign({ timeZone }, opts);
    return TimeslotApiUtils.fetch(args).then(
      (data) => {
        return dispatch(fetchSucceeded(data));
      },
      (error) => dispatch(fetchFailed(error)),
    );
  };
}

export function fetchByTutorSent() {
  return {
    type: FETCH_TIMESLOT_STATUSES_BY_TUTOR_SENT,
  };
}

export function fetchByTutorSucceeded(data) {
  return {
    type: FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED,
    payload: data,
  };
}

export function fetchByTutorFailed(error) {
  return {
    type: FETCH_TIMESLOT_STATUSES_BY_TUTOR_FAILED,
  };
}

export function fetchByTutor(tutorId, opts = {}) {
  return (dispatch) => {
    dispatch(fetchByTutorSent());
    return TimeslotApiUtils.fetchByTutor(tutorId, opts).then(
      (data) => dispatch(fetchByTutorSucceeded(data)),
      (error) => dispatch(fetchByTutorFailed(error)),
    );
  };
}

export function clearTutorsOnSlot() {
  return {
    type: CLEAR_TUTORS_ON_SLOT,
  };
}

export function fetchTutorsOnSlotSent() {
  return {
    type: FETCH_TUTORS_ON_SLOT_SENT,
  };
}

export function fetchTutorsOnSlotSucceeded(data) {
  return {
    type: FETCH_TUTORS_ON_SLOT_SUCCEEDED,
    payload: data,
  };
}

export function fetchTutorsOnSlotFailed(error) {
  return {
    type: FETCH_TUTORS_ON_SLOT_FAILED,
  };
}

export function fetchTutorsOnSlot(timestamp) {
  return (dispatch) => {
    dispatch(fetchTutorsOnSlotSent());
    return TimeslotApiUtils.fetchTutorsOnSlot(timestamp).then(
      (data) => dispatch(fetchTutorsOnSlotSucceeded(data)),
      (error) => dispatch(fetchTutorsOnSlotFailed(error)),
    );
  };
}
